import { EventEmitter } from 'events';

const CHANGE_EVENT = 'CHANGE';

export const BaseStore = {
  ...EventEmitter.prototype,
  emitChange(this: EventEmitter) {
    this.emit(CHANGE_EVENT);
  },

  addChangeListener(this: EventEmitter, callback: () => void) {
    this.on(CHANGE_EVENT, callback);
  },

  addOnceChangeListener(this: EventEmitter, callback: () => void) {
    this.once(CHANGE_EVENT, callback);
  },

  removeChangeListener(this: EventEmitter, callback: () => void) {
    this.removeListener(CHANGE_EVENT, callback);
  },
};

BaseStore.setMaxListeners(10000);
